const s = require("./jaoLogo.module.scss");

import * as React from "react";

const JaoLogo = () =>
    <div className={s.logo}></div>;

export default JaoLogo;